var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
import { html } from 'lit';
import { SgdfElement } from '../internal/sgdf-element.js';
import styles from './watching-count.styles.js';
import '../atoms/tag/tag.js';
import '../atoms/icon/icon.js';
/**
 * @summary A component to display the number of people has receive an "observation".
 * @status stable
 * @since 1.0
 *
 * @dependency sgdf-icon
 *
 */
class SgdfWatchingCount extends SgdfElement {
    constructor() {
        super(...arguments);
        this.count = 0;
    }
    render() {
        return html `<div class="watching-count">
            <sgdf-icon name="eye"></sgdf-icon>
            <p>${this.count}</p>
        </div>`;
    }
}
SgdfWatchingCount.styles = styles;
export default SgdfWatchingCount;
__decorate([
    property({
        type: Number,
    })
], SgdfWatchingCount.prototype, "count", void 0);
//# sourceMappingURL=watching-count.component.js.map